import React from "react";
import ConsultantCard from "./ConsultantCard";

export default function ConsultantList({

    consultants = [],

    loading = false,

    isLoggedIn = false,

    onConsultation,

    onViewProfile

}) {

    /******************************************************
     * Chargement
     ******************************************************/

    if (loading) {
        return (
            <div className="consultant-loading">
                <div className="spinner-border text-success">
                </div>
                <div className="mt-3">
                    Chargement des consultants...
                </div>
            </div>
        );

    }

    /******************************************************
     * Aucun résultat
     ******************************************************/

    if (consultants.length === 0) {
        return (
            <div className="consultant-empty">
                <i className="bi bi-search display-2 text-secondary"></i>
                <h3 className="mt-3">
                    Aucun consultant trouvé
                </h3>
                <p>
                    Essayez de modifier vos critères de recherche.
                </p>
            </div>
        );

    }

    /******************************************************
     * Liste
     ******************************************************/
    return (

        <div className="consultant-list">
            {
                consultants.map(
                    consultant => (
                        <ConsultantCard
                            key={consultant.id}
                            consultant={consultant}
                            isLoggedIn={isLoggedIn}
                            onConsultation={onConsultation}
                            onViewProfile={onViewProfile}
                        />
                    )
                )
            }
        </div>
    );

}